// @ts-nocheck

export const localeCodes =  [
  "sv",
  "en",
  "uk",
  "es",
  "fi"
]
export const localeLoaders = {
  sv: [
    {
      key: "locale_sv_46json_15bcf402",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_df9c2911",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_uk_46json_fd9f8e54",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_8f1921ed",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  fi: [
    {
      key: "locale_fi_46json_cdfeb67d",
      load: () => Promise.resolve({}),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/e788f297" /* webpackChunkName: "config_i18n_46config_46ts_e788f297" */)
]
export const normalizedLocales = [
  {
    code: "sv",
    iso: "sv-SE",
    domain: "stod.djurensratt.se",
    language: undefined,
    domains: [
      "stod.djurensratt.se"
    ],
    defaultForDomains: [
      "stod.djurensratt.se"
    ]
  },
  {
    code: "en",
    iso: "en-US",
    domain: "donate.project1882.org",
    language: undefined,
    domains: [
      "donate.project1882.org"
    ],
    defaultForDomains: []
  },
  {
    code: "uk",
    iso: "uk-UA",
    domain: "act-ua.project1882.org",
    language: undefined,
    domains: [
      "act-ua.project1882.org"
    ],
    defaultForDomains: [
      "act-ua.project1882.org"
    ]
  },
  {
    code: "es",
    iso: "es-ES",
    domain: "donate.project1882.org",
    language: undefined,
    domains: [
      "donate.project1882.org"
    ],
    defaultForDomains: []
  },
  {
    code: "fi",
    iso: "fi-FI",
    domain: "donate.project1882.org",
    language: undefined,
    domains: [
      "donate.project1882.org"
    ],
    defaultForDomains: []
  }
]

